import { bindable } from 'aurelia-framework';

export interface IRuleValidationException {
	invalidValue: string;
	ruleIdentifier: string;
	ruleDefinitionRow: string;
	rowNumber: number;
	message: string;
}

export class AccountingRuleErrorDisplay {
	@bindable errorInRule: IRuleValidationException;
}
